<div class="container-fluid">
<div class="row">
    <div class="col-12 col-md-6 mb-2">
        <div class="d-flex flex-row justify-content-between">
            <h1 class="card-title mb-0">Banker Group Management</h1>
            <button class="btn btn-primary btn-sm" [routerLink]="['/lo', selected_company, 'banker-group-management', 'form']">New Group</button>
        </div>
    </div>
</div>
<div class="row">
    <div class="col-12 col-md-6">
        <table class="table table-bordered table-striped table-sm">
            <thead>
                <tr>
                    <th>Name</th>
                    <th>Status</th>
                    <th>View</th>
                    <th>Edit</th>
                    <th>Delete</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let group of groups">
                    <td>{{group.name}}</td>
                    <td>{{group.status == 1 ? 'Active' : 'Disabled'}}</td>
                    <td>
                        <button class="btn btn-primary btn-sm" [routerLink]="['/lo', selected_company, 'banker-group-detail', group.uuid]">View</button>
                    </td>
                    <td>
                        <button class="btn btn-primary btn-sm" [routerLink]="['/lo', selected_company, 'banker-group-management', 'form', group.uuid]">Edit</button>
                    </td>
                    <td>
                        <button class="btn btn-danger btn-sm" (click)="delete(group.uuid)">Delete</button>
                    </td>
                </tr>
                <tr *ngIf="groups.length == 0">
                    <td colspan="4" class="text-center">No data found</td>
                </tr>
            </tbody>
        </table>
    </div>
</div>
</div>